import React from 'react';

import Box from '@mui/material/Box';

import PatientSchedulingTimeForm from './PatientSchedulingTimeForm';

const ScheduleSpecificProviderForm = ({
  providerId,
  serviceCategory,
  lat,
  lon,
  distance = 30,
  onSubmit,
  defaultDate = new Date(),
  onSendMessage = null,
  providerTimezone = null,
}) => {
  return (
    <Box>
      <PatientSchedulingTimeForm
        providerId={providerId}
        serviceCategory={serviceCategory}
        lat={lat}
        lon={lon}
        distance={distance}
        onSubmit={onSubmit}
        defaultDate={defaultDate}
        onSendMessage={onSendMessage}
        hideLocationTypes={true}
        showTimezone={true}
        providerTimezone={providerTimezone}
      />
    </Box>
  );
};

export default ScheduleSpecificProviderForm;